import { createAction, createReducer, createSelector } from '@reduxjs/toolkit';
import type { StorytellerState } from './StorytellerReduxState';

export interface PageLoadingState {
  loading: boolean;
  message: string | null;
}

const initialState: PageLoadingState = {
  loading: false,
  message: null,
};

export enum PageLoadingActions {
  SET_LOADING = 'SET_LOADING',
}

export const setPageLoading = createAction<Partial<PageLoadingState>>(PageLoadingActions.SET_LOADING);

export const pageLoadingReducer = createReducer<PageLoadingState>(initialState, (builder) => {
  builder.addCase(setPageLoading, (state: PageLoadingState, { payload }) => ({ ...state, ...payload }));
});

export const selectPageLoadingState = (state: StorytellerState) => state.pageLoading;

export const selectPageLoading = createSelector(selectPageLoadingState, (it) => it.loading);

export const selectPageLoadingText = createSelector(selectPageLoadingState, (it) => it.message);
